/**
 * English translations for company settings page.
 */

const companySettings = {
  // Page title
  title: 'Settings',
  subtitle: 'Manage your company profile and preferences',

  // Tabs
  tabs: {
    profile: 'Profile',
    notifications: 'Notifications',
    display: 'Display',
  },

  // Profile tab
  profile: {
    heading: 'Company Profile',
    description: 'Update your company information visible to customers',
    // Logo section
    logo: {
      title: 'Company Logo',
      dragDrop: 'Drag and drop your logo here, or click to browse',
      restrictions: 'PNG or JPG, max 5MB',
      remove: 'Remove Logo',
      removeConfirm: 'Remove company logo?',
      removeDescription: 'This will remove the current logo. You can upload a new one anytime.',
      uploading: 'Uploading...',
    },
    // Form fields
    fields: {
      name: 'Company Name (English)',
      nameAr: 'Company Name (Arabic)',
      email: 'Contact Email',
      phone: 'Phone Number',
      address: 'Address',
      description: 'Description (English)',
      descriptionAr: 'Description (Arabic)',
      website: 'Website',
    },
    // Placeholders
    placeholders: {
      name: 'Enter company name',
      nameAr: 'Enter company name in Arabic',
      email: 'contact@company.com',
      phone: '+966 5X XXX XXXX',
      address: 'Street address, city',
      description: 'Brief description of your company',
      descriptionAr: 'Brief description in Arabic',
      website: 'https://www.example.com',
    },
    // Validation
    validation: {
      nameRequired: 'Company name is required',
      nameMinLength: 'Company name must be at least 2 characters',
      emailInvalid: 'Please enter a valid email address',
      websiteInvalid: 'Please enter a valid URL',
    },
    // Actions
    save: 'Save Changes',
    saving: 'Saving...',
    saved: 'Profile updated successfully',
    saveError: 'Failed to update profile',
  },

  // Notifications tab
  notifications: {
    heading: 'Notification Preferences',
    description: 'Choose how you want to be notified about team and listing activity',
    // Sections
    teamActivity: {
      title: 'Team Activity',
      description: 'Get notified when team members join, leave, or change roles',
      email: 'Email notifications',
      inApp: 'In-app notifications',
    },
    listingEvents: {
      title: 'Listing Events',
      description: 'Get notified about listing status changes and inquiries',
      email: 'Email notifications',
      inApp: 'In-app notifications',
    },
    save: 'Save Preferences',
    saving: 'Saving...',
    saved: 'Preferences updated successfully',
    saveError: 'Failed to update preferences',
  },

  // Display tab
  display: {
    heading: 'Display Preferences',
    description: 'Customize how the app looks and feels',
    language: {
      title: 'Language',
      description: 'Choose your preferred language',
      english: 'English',
      arabic: 'Arabic',
    },
    theme: {
      title: 'Theme',
      description: 'Choose your preferred color scheme',
      light: 'Light',
      dark: 'Dark',
      system: 'System',
    },
    note: 'These settings are saved locally to your browser.',
  },

  // Unsaved changes dialog
  unsavedChanges: {
    title: 'Unsaved Changes',
    message: 'You have unsaved changes. Do you want to save them before leaving?',
    save: 'Save',
    discard: 'Discard',
    cancel: 'Cancel',
  },

  // Crop modal
  crop: {
    title: 'Crop Image',
    instructions: 'Drag to position, scroll to zoom',
    cancel: 'Cancel',
    apply: 'Apply',
  },

  // Role permission message
  noPermission: 'Only company owners and admins can edit settings',
};

export default companySettings;
